import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const profileRolesRoute: RouteConfig = {
  path: 'roles',
  name: 'profileRoles',
  component: () => import(/* webpackChunkName: "ProfileRoles" */ '@/views/mainRoute/profile/Roles.vue'),
  meta: {
    title: 'Role'
  },
  beforeEnter(to: any, from: any, next: any) {
    Promise.all([store.dispatch('role/list', { count: -1 }), store.dispatch('profile/roles/list')])
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.PROFILE_CANNOT_LIST_ROLES }));
  }
};
